import type { ChatwootCannedResponse } from './types'

// The "#" command query currently being typed at the end of the composer
// (after start or whitespace), or null when no trigger is active. (REQ-03)
export function cannedQueryAt(content: string): string | null {
  const match = content.match(/(?:^|\s)#(\S*)$/)
  return match ? match[1] : null
}

export function filterCanned(
  canned: ChatwootCannedResponse[],
  query: string
): ChatwootCannedResponse[] {
  const normalized = query.toLowerCase()
  return canned.filter(
    (item) =>
      item.shortCode.toLowerCase().includes(normalized) ||
      item.content.toLowerCase().includes(normalized)
  )
}

// Replace the trailing "#query" token with the canned content, preserving the
// preceding whitespace. The result is an editable draft, never auto-sent.
export function insertCanned(content: string, cannedContent: string): string {
  return content.replace(
    /(^|\s)#\S*$/,
    (_match, prefix) => `${prefix}${cannedContent}`
  )
}
